export const MENULIST = {
  DEFAULT_MENU: {
    WELCOME_MESSAGE: {
      name: 'welcome_message',
      icon: 'fa fa-handshake-o',
      path: 'welcome'
    },
    CONVERSATION: {
      name: 'conversation',
      icon: 'fa fa-comments',
      path: 'conversation'
    },
    REPLY_COMMENT: {
      name: 'reply_comment',
      icon: 'fa fa-reply',
      path: 'comment'
    },
    BROADCAST: {
      name: 'broadcast',
      icon: 'fas fa-bullhorn',
      path: 'broadcast'
    },
    TICKETING: {
      name: 'ticketing',
      icon: 'fas fa-ticket-alt',
      path: 'ticket'
    },
    LIVECHAT: {
      name: 'livechat',
      icon: 'fa fa-commenting',
      path: 'allinonechat'
    },
    ANALYTICS: {
      name: 'chatbot_analytics',
      icon: 'fas fa-chart-line',
      path: 'dashboard'
    },
    TRAINING: {
      name: 'training',
      icon: 'fas fa-dumbbell',
      path: 'training'
    },
    SETTING: {
      name: 'setting',
      icon: 'fa fa-cog',
      path: 'billing'
    },
    USER_MANAGEMENT: {
      name: 'user_management',
      icon: 'fas fa-users-cog',
      path: 'agent-management'
    }
  },

  CUSTOMIZE_MENU: {
    TTB: {
      PROFILE: {
        name: 'check_in_check_out',
        icon: 'fas fa-user-clock',
        path: 'ttb/profile'
      },
      DASHBOARD_NONVOICE: {
        name: 'dashboard_nonvoice',
        icon: 'fa fa-bar-chart',
        path: 'ttb/dashboard-nonvoice'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/menuList.js